import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';
import {HttpClient} from '@angular/common/http';
import {
  GetUsersApiData,
  GetUsersApiDataFormatted,
  GetUsersUrlParams,
  UserProfileApiData,
  PutUserPasswordApiData,
  PutUserPasswordReqObj,
  PostPutUserProfileReqObj, PutUserUrlParams, GetBusinessUsersApiDataFormatted, GetBusinessUsersApiData
} from './users-http-interfaces';

const USERS_API_ROUTES = {
  GET_USERS: 'admin/users',
  POST_USER: 'admin/users',
  PUT_USER: 'admin/users/:userId',
  APPROVE_USER: 'admin/users/verify-email',
  DELETE_USER: 'admin/users/:userId',
  PUT_AUTH_USER_PASSWORD: 'users/update-password',
  PUT_AUTH_USER_PROFILE: 'users',
  GET_ALL_USERS_FOR_NOTIFICATIONS: 'custom-notifications/role/:role'
};
@Injectable({
  providedIn: 'root'
})
export class UsersHttpService {

  constructor(private generalHttpHelperService: GeneralHttpHelperService,
              private httpClient: HttpClient) { }

  private getUsersReq(urlParams: GetUsersUrlParams): Observable<GetUsersApiData> {
    const url = this.generalHttpHelperService.addUrlParams(USERS_API_ROUTES.GET_USERS, urlParams);
    return this.httpClient.get(url) as any;
  }

  getUsers(urlParams: GetUsersUrlParams): Promise<GetUsersApiDataFormatted> {
    return new Promise<GetUsersApiDataFormatted>((resolve, reject) => {
      this.getUsersReq(urlParams).subscribe((res: GetUsersApiData) => {
        resolve(
          {
            data: res.data.data,
            pagination: this.generalHttpHelperService.returnPagination(res.data)
          }
        );
      }, error => {
        reject(error);
      });
    });
  }


  private getBusinessUsersReq(urlParams: GetUsersUrlParams): Observable<GetBusinessUsersApiData> {
    const url = this.generalHttpHelperService.addUrlParams(USERS_API_ROUTES.GET_USERS, urlParams);
    return this.httpClient.get(url) as any;
  }

  getBusinessUsers(urlParams: GetUsersUrlParams): Promise<GetBusinessUsersApiDataFormatted> {
    return new Promise<GetBusinessUsersApiDataFormatted>((resolve, reject) => {
      this.getBusinessUsersReq(urlParams).subscribe((res: GetBusinessUsersApiData) => {
        resolve(
          {
            active: res.active,
            inactive: res.inactive,
            data: res.data.data,
            pagination: this.generalHttpHelperService.returnPagination(res.data)
          }
        );
      }, error => {
        reject(error);
      });
    });
  }

  private postUserReq(bodyParams: PostPutUserProfileReqObj): Observable<UserProfileApiData> {
    return this.httpClient.post(USERS_API_ROUTES.POST_USER, bodyParams) as any;
  }

  postUser(bodyParams: PostPutUserProfileReqObj): Promise<UserProfileApiData> {
    return new Promise<UserProfileApiData>((resolve, reject) => {
      this.postUserReq(bodyParams).subscribe((res: UserProfileApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private putUserReq(urlParams: PutUserUrlParams, bodyParams: PostPutUserProfileReqObj): Observable<UserProfileApiData> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(USERS_API_ROUTES.PUT_USER, urlParams);
    return this.httpClient.put(url, bodyParams) as any;
  }

  putUser(urlParams: PutUserUrlParams, bodyParams: PostPutUserProfileReqObj): Promise<UserProfileApiData> {
    return new Promise<UserProfileApiData>((resolve, reject) => {
      this.putUserReq(urlParams, bodyParams).subscribe((res: UserProfileApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private deleteUserReq(urlParams: Record<string, number>): Observable<UserProfileApiData> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(USERS_API_ROUTES.DELETE_USER, urlParams);
    return this.httpClient.delete(url) as any;
  }

  deleteUser(urlParams: Record<string, number>): Promise<UserProfileApiData> {
    return new Promise<UserProfileApiData>((resolve, reject) => {
      this.deleteUserReq(urlParams).subscribe((res: UserProfileApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }


  private putAuthUserReq(bodyParams: PostPutUserProfileReqObj): Observable<UserProfileApiData> {
    return this.httpClient.put(USERS_API_ROUTES.PUT_AUTH_USER_PROFILE, bodyParams) as any;
  }

  putAuthUser(bodyParams: PostPutUserProfileReqObj): Promise<UserProfileApiData> {
    return new Promise<UserProfileApiData>((resolve, reject) => {
      this.putAuthUserReq(bodyParams).subscribe((res: UserProfileApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private putAuthUserPasswordReq(bodyParams: PutUserPasswordReqObj): Observable<PutUserPasswordApiData> {
    return this.httpClient.put(USERS_API_ROUTES.PUT_AUTH_USER_PASSWORD, bodyParams) as any;
  }
  putAuthUserPassword(bodyParams: PutUserPasswordReqObj): Promise<PutUserPasswordApiData> {
    return new Promise<UserProfileApiData>((resolve, reject) => {
      this.putAuthUserPasswordReq(bodyParams).subscribe((res: PutUserPasswordApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private approveUserReq(userID: number): Observable<any> {
    return this.httpClient.get(`${USERS_API_ROUTES.APPROVE_USER}/${userID}`) as any;
  }

  approveUser(userID: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.approveUserReq(userID).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getAllUsersReq(role: string,urlParams?: {search: string}): Observable<any> {
    const route = `admin/custom-notifications/role/${role}`;
      const url = this.generalHttpHelperService.addUrlParams(route, urlParams);
    return this.httpClient.get(url) as any;
  }
  getAllUsers(role: string,urlParams?: {search: string}): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getAllUsersReq(role,urlParams).subscribe((res: any) => {
        resolve(
          res.data
        );
      }, error => {
        reject(error);
      });
    });
  }

}
